import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {onClickSearchResult} from '../../actions/navOptions';
import AvatarImage from '../AvatarImage';

class ParkingSpotSearchResult extends Component {

  renderSpotButton(spotId, uidAssignment) {
    return (
      <a href="#"
         className="btn btn-default color-primary"
         onClick={() => {this.props.onClickSearchResult(spotId);}}
         key={`${uidAssignment}-${spotId}`}
      >
        {spotId}&nbsp;<i className="fa fa-caret-right" />
      </a>
    );
  }

  formatClassInfo(classInfo) {
    return (
      classInfo.map((info, i) => {
        return <span key={i}>
          {info.vehicleNumber ? `#${info.vehicleNumber}` : '' } {info.class}{info.class && i < classInfo.length - 1 ? ', ' : '' }
        </span>
      })
    )
  }

  searchResultItem() {
    const { data } = this.props;
    const { spotIdentifier, uidAssignment } = data;

    const parkingSpotButtons = spotIdentifier.map((spotId, i) => {
      return this.renderSpotButton(spotId, uidAssignment[i]);
    });

    return (
      <li className="clearfix">
        <div className="media">
          {this.renderProfileImage(data.avatar)}
          <div className="media-body">
            <strong>{`${data.firstName} ${data.lastName}`}</strong>
            { this.formatClassInfo(data.classInfo) }
          </div>
        </div>

        <div className="pull-right">
          {
            spotIdentifier.length ? <div>{parkingSpotButtons}</div> : <em>No spot</em>
          }
        </div>
      </li>
    );
  }

  renderProfileImage(avatar) {
    return <AvatarImage avatar={avatar} style={{width: '40px', height: '40px'}} entity="searchResult" />;
  }

  render() {
    return (
      this.searchResultItem()
    )
  }

}

const bindDispatchToProps = (dispatch) => {
  return bindActionCreators({onClickSearchResult}, dispatch);
};

export default connect(undefined, bindDispatchToProps)(ParkingSpotSearchResult);



// WEBPACK FOOTER //
// ./src/containers/Search/ParkingSpotSearchResult.js